import { Breadcrumbs, Button, Grid, Paper, makeStyles } from "@material-ui/core";
import { PersonAdd, Search } from "@material-ui/icons";
import { useState } from "react";
import { GestionSolicitudes } from "./Components/GestionSolicitudes";
import { useEffect } from "react";
import { useSurge } from "../../hooks/useCases/useSurge";
import { SolicitudForm } from "./Components/SolicitudForm";
import { GestionImagenesAutorizaciones } from "./Components/GestionImagenesAutorizaciones";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    },
    tabs: {
        marginTop: "1rem",
    },
    button: {
        textAlign: "center",
    },
}));

const style = {
    root: {
        flexGrow: 1,
    },
};

export const HomeRecuperos = () => {
    const classes = useStyles();
    const surge = useSurge();
    const [menu, setMenu] = useState(0);

    useEffect(() => { surge.get.all.estadosSolicitudes() }, [])

    return (
        <div className={classes.root}>
            <Grid container spacing={1} direction="row" justify="center" alignItems="center" >
                <Grid item xs={12} styles={{ padding: 5 }}>
                    <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
                        <Button color={"inherit"}
                            onClick={() => { setMenu(1) }}>
                            <PersonAdd className={style.icon} />
                            Ingreso de solicitud
                        </Button>
                        <Button color={"inherit"}
                            onClick={() => { setMenu(2) }}>
                            <Search className={style.icon} />
                            Gestión de legajos
                        </Button>
                        <Button color={"inherit"}
                            onClick={() => { setMenu(3) }}>
                            <Search className={style.icon} />
                            Gestión imagenes Autorizaciones
                        </Button>
                    </Breadcrumbs>
                </Grid>
                <Grid item xs={12} md={11} style={{ marginTop: "1em" }}>
                    {menu === 1 && (
                        <Paper style={{ padding: "1rem", margin: '3rem' }}>
                            <SolicitudForm />
                        </Paper>
                    )}
                    {menu === 2 && (
                        <Paper style={{ padding: "1rem", margin: '3rem' }}>
                            <GestionSolicitudes />
                        </Paper>
                    )}
                    {menu === 3 && (
                        <GestionImagenesAutorizaciones />
                    )}
                </Grid>
            </Grid>
        </div>
    )
}
